import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-product\"><path d=\"M97.792 787.712l30.72-558.08c3.4304-62.976 54.1184-112.64 115.3536-112.64h535.296c61.44 0 111.9232 49.3568 115.4048 112.64l30.72 558.08a121.344 121.344 0 0 1-32.8704 89.856 113.0496 113.0496 0 0 1-82.688 35.84H213.1968a112.9984 112.9984 0 0 1-82.7392-35.84 121.344 121.344 0 0 1-32.6656-89.856z m77.2608 47.616a52.2752 52.2752 0 0 0 38.144 16.6912h596.48a52.224 52.224 0 0 0 38.144-16.6912 59.8016 59.8016 0 0 0 15.872-44.2368l-30.72-558.08c-1.5872-30.4128-25.6-54.272-53.9648-54.272H243.712c-28.672 0-52.3264 23.8592-54.016 54.272l-30.72 558.08a59.9552 59.9552 0 0 0 16.0768 44.2368z\" p-id=\"1932\" /><path d=\"M351.744 278.528a30.72 30.72 0 0 1 30.72 30.72c0 74.7008 57.856 135.5264 128.9728 135.5264 71.1168 0 128.9728-60.7744 128.9728-135.5264a30.72 30.72 0 1 1 61.44 0c0 108.544-85.4016 196.9664-190.4128 196.9664S321.024 417.792 321.024 309.248a30.72 30.72 0 0 1 30.72-30.72z\" p-id=\"1933\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product.svg
// module id = UHi4
// module chunks = 41